import { useState } from "react";
import { connect } from "react-redux";
import Button from "../../Components/Button/Button";
import Footer from "../../Components/Footer/Footer";
import Header from "../../Components/Header/Header";
import Modal from "../../Components/Modal/Modal";
import RoundedProfilePicture from "../../Components/RoundedProfilePicture/RoundedProfilePicture";
import { logout } from "../../Redux/authentication/actions";
import { setSuccessStatus } from "../../Redux/status/action";

function Profile(props) {
  const [modal, setModal] = useState({
    logout: false,
    clearCache: false
  });

  const data = [
    {
      title: "Name",
      value: props.profile?.data?.name
    },
    {
      title: "Phone Number",
      value: props.profile?.data?.phoneNumber
    }
  ];

  const clearSiteCache = async () => {
    localStorage.clear();
    sessionStorage.clear();

    if ("caches" in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map((name) => caches.delete(name)));
    }

    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (let reg of registrations) {
        await reg.unregister();
      }
    }

    logout();

    setSuccessStatus(
      "Cache cleared successfully. Please log in again to continue."
    );
    window.location.reload();
  };

  return (
    <div className="inherit-parent-height inherit-parent-width">
      <Header
        title="Profile"
        backOnClick={() => {
          props.navigate(-1);
        }}
        logoutOnClick={() => {
          setModal({ logout: true, clearCache: false });
        }}
      />
      <div
        style={{
          height: "calc(100% - 134px)"
        }}
        className="flex-justify-content-space-between flex-direction-column"
      >
        <div className="remaining-body-height inherit-parent-width display-flex flex-justify-content-center overflow-x-scroll hide-scrollbar">
          <div className=" inherit-parent-height inherit-parent-width max-width-767px padding-top-larger">
            <div className="flex-justify-content-center flex-align-items-center flex-direction-column padding-bottom-larger">
              <RoundedProfilePicture
                // editMode={true}
                size="large"
                // src={
                //   profileData.profilePicture
                //     ? URL.createObjectURL(profileData.profilePicture)
                //     : props.data.profilePictureUrl
                // }
                // setFile={(file) => {
                //   setFile(file);
                // }}
              />
            </div>
            <div className="padding-large">
              {data.map((data, index) => (
                <div className="padding-bottom-large" key={index}>
                  <div className="text-uppercase padding-bottom-default font-size-small">
                    {data.title}
                  </div>
                  <div>{data.value}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="display-flex flex-justify-content-center font-size-medium padding-bottom-large">
        <div>Trouble with the app ? </div>
        <div
          data-cy="CLEAR-CACHE-BUTTON"
          className="font-color-primary padding-left-default"
          onClick={() => {
            setModal({ logout: false, clearCache: true });
          }}
        >
          Clear cache
        </div>
      </div>
      <Footer
        description={`App version ${
          process.env.REACT_APP_BUILD_NUM?.toString() || "1.0.0"
        }`}
      />

      <Modal
        show={modal.logout}
        canIgnore={true}
        onClose={() => {
          setModal({ logout: false, clearCache: false });
        }}
        width="inherit-parent-width"
        position=" absolute-center-self-horizontally bottom-0 "
        maxWidth="max-width-630px"
        background="false"
        boxShadow="false"
        borderRadius="false"
        height="height-fit-to-content"
      >
        <section className="font-color-secondary font-family-gilroy-medium font-color-secondary text-align-center padding-larger background-white">
          <div className=" font-family-RHD-medium font-size-medium">LOGOUT</div>
          <div className=" padding-top-default">
            Are you sure to logout from the application?
          </div>

          <section className="display-flex padding-top-larger ">
            <Button
              boxShadow={false}
              type="submit"
              variant="danger"
              text="Yes"
              className={"border-1px-e5e5e5 margin-right-small"}
              onClick={() => {
                props.logout();
              }}
              data-cy={"confirm-logout-button"}
            />
            <Button
              boxShadow={false}
              text="No"
              variant={"secondary"}
              onClick={() => {
                setModal({ logout: false, clearCache: false });
              }}
              className={
                "font-color-secondary border-1px-e5e5e5 margin-left-small"
              }
              data-cy={"cancel-logout-button"}
            />
          </section>
        </section>
      </Modal>

      <Modal
        show={modal.clearCache}
        canIgnore={true}
        onClose={() => {
          setModal({ logout: false, clearCache: false });
        }}
        width="inherit-parent-width"
        position=" absolute-center-self-horizontally bottom-0 "
        maxWidth="max-width-630px"
        background="false"
        boxShadow="false"
        borderRadius="false"
        height="height-fit-to-content"
      >
        <section className="font-color-secondary font-family-gilroy-medium font-color-secondary text-align-center padding-larger background-white">
          <div className=" font-family-RHD-medium font-size-medium">
            Clear cache
          </div>
          <div className=" padding-top-default">
            Clearing cache will log you out. Log back in to get the latest app
            version and updates.
          </div>

          <section className="display-flex padding-top-larger ">
            <Button
              boxShadow={false}
              type="submit"
              text="Yes"
              className={"border-1px-e5e5e5 margin-right-small"}
              onClick={() => {
                clearSiteCache();
              }}
              data-cy="CONFIRM-CLEAR-CACHE-BUTTON"
            />
            <Button
              boxShadow={false}
              text="No"
              variant={"secondary"}
              onClick={() => {
                setModal({ logout: false, clearCache: false });
              }}
              className={
                "font-color-secondary border-1px-e5e5e5 margin-left-small"
              }
              data-cy="CANCEL-CLEAR-CACHE-BUTTON"
            />
          </section>
        </section>
      </Modal>
    </div>
  );
}

const mapStateToProps = function (state) {
  return {
    auth: state.auth,
    profile: state.profile
  };
};

const mapDispatchToProps = function () {
  return {
    logout: () => logout()
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Profile);
